import React from 'react';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { SALES_TABLE_HEADER_DISPLAY_NAMES } from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/constants';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_SALES
  },
  {
    name: 'wholesaleSales',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.WHOLESALE_SALES
  },
  {
    name: 'retailPrice',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_PRICE
  },
  {
    name: 'retailerGrossMargin',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAILER_GROSS_MARGIN
  },
  {
    name: 'brandGrossMargin',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.BRAND_GROSS_MARGIN
  },
  {
    name: 'brandCogs',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.BRAND_COGS
  }
];

/**
 * Shows the retailer margin by product for the sales page
 */
const MarginsProductGrid = () => {
  const { isProductEntity } = useProductEntity();

  const fieldsToUse = isProductEntity ? fields.map(removeComparisonFormatter) : fields;

  return isProductEntity ? (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Retailer Margin by Week'
      }}
      indexName="sales"
      sortFieldName="retailerGrossMargin"
      fields={fieldsToUse}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <ProductListContainer
      entityTableHeaderProps={{
        title: 'Retailer Margin by Product'
      }}
      indexName="sales"
      sortFieldName="retailerGrossMargin"
      fields={fieldsToUse}
    />
  );
};

export default MarginsProductGrid;
